import React from 'react'
import BiteForm from '../../components/DashComponents/Forms/BiteForm'

function UpdateBite() {
  return (
    <BiteForm/>
  )
}

export default UpdateBite